// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"823":"365dbbfa","884":"1b24a4e9"}[chunkId] + ".chunk.js";
};